import { useState } from "react";

import { useAsync } from "@smart/itops-hooks-dom";
import { Matter, useSmokeballApp } from "@smart/itops-smokeball-app-dom";
import {
  MatterSubmission,
  useLoadMatterType,
} from "@smart/manage-gql-client-dom";
import { useRoleContacts } from "@smart/manage-hooks-dom";

import { SubmissionActions } from "./actions";

type SubmissionActionsWithoutMatterContextProps = {
  refetch?: () => void;
} & Record<
  "cancelling" | "deleting" | "reminding",
  { selected?: MatterSubmission; onClose: () => void }
>;

export const SubmissionActionsWithoutMatterContext = ({
  cancelling,
  deleting,
  reminding,
  refetch,
}: SubmissionActionsWithoutMatterContextProps) => {
  const [matter, setMatter] = useState<Matter | undefined>();
  const [loadingMatter, setLoadingMatter] = useState(false);
  const { matters } = useSmokeballApp();

  const submission =
    cancelling.selected || deleting.selected || reminding.selected;
  const matterId = submission?.rawSubmission.values.matterId;
  const matterTypeId =
    submission?.rawSubmission.matter?.matterTypeId || matter?.matterTypeId;

  const roleContacts = useRoleContacts({
    matterId,
  });
  const loadMatterType = useLoadMatterType(
    {
      matterTypeId: matterTypeId || "",
    },
    { skip: !matterTypeId },
  );

  useAsync(async () => {
    if (matterId) {
      setLoadingMatter(true);
      const targetMatter = await matters?.get(matterId);
      setMatter(targetMatter);
      setLoadingMatter(false);
    } else {
      setMatter(undefined);
    }
  }, [matterId]);

  const matterType =
    loadMatterType.loading || !matter
      ? undefined
      : loadMatterType.result || { name: "", id: "" };

  return (
    <SubmissionActions
      isLoadingMatterInfo={
        loadingMatter || loadMatterType.loading || roleContacts.isLoading
      }
      matter={matter}
      matterType={matterType}
      roleContacts={roleContacts}
      onViewClose={() => {}}
      cancelling={cancelling}
      deleting={deleting}
      reminding={reminding}
      refetch={refetch}
    />
  );
};
